import * as React from 'react';

import { SearchField, Select } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';

import * as state from '../../_state/userList.state';
import { useTranslations } from '../../i18n/useTranslations';

import { SelectOrganization } from '~/shared/components/select-fields/SelectOrganization';
import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const UserListFilterBar = () => {
  const t = useTranslations();
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);
  const [selectedOrganizationId, setSelectedOrganizationId] = useAtom(
    state.$selectedOrganizationId,
  );
  const [statusFilter, setStatusFilter] = useAtom(state.$status);
  const setOffset = useSetAtom(state.$offset);

  const handleOrganizationChange = React.useCallback(
    (value: string | undefined) => {
      setSelectedOrganizationId(value);
      setOffset(0);
    },
    [setSelectedOrganizationId, setOffset],
  );

  const handleStatusChange = React.useCallback(
    (key: string) => {
      setStatusFilter(key as 'all' | 'ACTIVE' | 'ARCHIVED');
      setOffset(0);
    },
    [setStatusFilter, setOffset],
  );

  const handleSearchChange = React.useCallback(
    (value: string) => {
      setSearchTerm(value);
      setOffset(0);
    },
    [setSearchTerm, setOffset],
  );

  return (
    <>
      <SelectOrganization
        label={t.userListView.filterByOrganization}
        placeholder={t.userListView.filterByOrganization}
        className="w-[250px]"
        value={selectedOrganizationId}
        onChange={handleOrganizationChange}
      />

      <Select<'all' | 'ACTIVE' | 'ARCHIVED'>
        aria-label={t.userListView.filterByStatus}
        placeholder={t.userListView.filterByStatus}
        className="w-[200px]"
        value={statusFilter}
        onChange={handleStatusChange}
        options={[
          { key: 'all', label: t.userListView.status.all },
          { key: 'ACTIVE', label: t.userListView.status.active },
          { key: 'ARCHIVED', label: t.userListView.status.archived },
        ]}
      />

      <SearchField
        autoFocus
        aria-label={t.userListView.searchPlaceholder}
        placeholder={t.userListView.searchPlaceholder}
        className="w-[250px]"
        value={searchTerm}
        onChange={handleSearchChange}
      />
    </>
  );
};
